/**
 * Shared presentational pieces for the /figma design sandbox
 */

import styled from 'styled-components'

export const PageShell = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  display: flex;
  flex-flow: column;
  padding: 28px 16px 64px;
  box-sizing: border-box;
  background: var(--neutral-white);
  color: var(--neutral-body);

  /* Wide gutters only when there is room beyond the desktop preview width */
  @media (min-width: 1441px) {
    padding: 28px 72px 64px;
  }

  @media (max-width: 768px) {
    padding: 20px 16px 48px;
  }
`

export const PageTitle = styled.h1`
  margin: 0 0 4px;
  font: 700 32px/38px var(--font-barlow-semi-condensed);
  color: var(--neutral-darkest);
  letter-spacing: 0;
`

export const PageIntro = styled.p`
  margin: 0 0 20px;
  max-width: 720px;
  font: 400 14px/22px var(--font-inter);
  color: var(--neutral-secondary);

  code {
    font-size: 12px;
    padding: 1px 4px;
    background: var(--neutral-fill-lightest);
    border: 1px solid var(--neutral-border-light);
  }

  a {
    color: var(--neutral-darkest);
  }
`

export const SectionTitle = styled.h2`
  margin: 32px 0 8px;
  font: 600 24px/30px var(--font-barlow-semi-condensed);
  color: var(--neutral-darkest);
  letter-spacing: 0.4px;
`

export const SectionSub = styled.p`
  margin: 0 0 16px;
  font: 400 13px/20px var(--font-inter);
  color: var(--neutral-secondary);
`

export const GroupTitle = styled.h3`
  margin: 20px 0 12px;
  font: 600 14px/20px var(--font-barlow);
  color: var(--neutral-darkest);
  letter-spacing: 1px;
  text-transform: uppercase;
`

export const StatusBadge = styled.span<{ status: 'implemented' | 'mismatch' | 'missing' }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  font: 600 10px/14px var(--font-barlow);
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${({ status }) =>
    status === 'implemented'
      ? 'var(--accent-green)'
      : status === 'mismatch'
        ? '#8a5a00'
        : 'var(--neutral-secondary)'};
  background: ${({ status }) =>
    status === 'implemented'
      ? 'var(--accent-trans-lime)'
      : status === 'mismatch'
        ? '#fff4d6'
        : 'var(--neutral-fill-lightest)'};
  border: 1px solid
    ${({ status }) =>
      status === 'implemented'
        ? 'transparent'
        : status === 'mismatch'
          ? '#e6c35c'
          : 'var(--neutral-border-light)'};
`

export const MetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
`

export const MetaCode = styled.code`
  font-size: 11px;
  line-height: 16px;
  color: var(--neutral-body);
  word-break: break-all;
`

export const DemoGrid = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: var(--spacing-16);
  border: 1px dashed var(--neutral-border-med);
  padding: 16px;
  background: var(--neutral-white);
`

export const Legend = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
`

export const TabsWrap = styled.div`
  .ant-tabs-bar {
    margin-bottom: 16px;
    border-bottom: 1px solid var(--neutral-border-light);
  }

  .ant-tabs-tab {
    font: 600 12px/18px var(--font-barlow);
    letter-spacing: 1px;
    text-transform: uppercase;
    color: var(--neutral-secondary);
    padding: 10px 4px;
  }

  .ant-tabs-tab-active {
    color: var(--neutral-darkest);
  }

  .ant-tabs-ink-bar {
    background: var(--neutral-darkest);
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/theme/sandbox/sandboxStyles.ts